export const types = {
    GETTING_COMPANIES: 'GETTING_COMPANIES',
    GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
    GET_COMPANIES_FAIL: 'GET_COMPANIES_FAIL',
  }
